import { __exportAll } from "../_virtual/_rolldown/runtime.js";
import { UniversalTime } from "@biteinc/helpers-universal";
//#region src/utils/menu_timing_utils.ts
var menu_timing_utils_exports = /* @__PURE__ */ __exportAll({
	isActiveAt: () => isActiveAt,
	rangeThatIsActiveAt: () => rangeThatIsActiveAt
});
function isActiveAt(data, time, timezone) {
	if (data.dateRange) {
		if (time < data.dateRange.from || data.dateRange.to <= time) return false;
	}
	return !!rangeThatIsActiveAt(data, UniversalTime.weekTimestamp(time, timezone));
}
function rangeThatIsActiveAt(data, weekTimestamp) {
	return UniversalTime.rangeThatIsActiveAt(data, weekTimestamp);
}
//#endregion
export { isActiveAt, menu_timing_utils_exports, rangeThatIsActiveAt };

//# sourceMappingURL=menu_timing_utils.js.map